class NexorTheme {
  constructor(root = document) {
    this.root = root;
    this.initMenu();
    this.initSearch();
    this.initHeroSliders();
    this.initProductForms();
    this.initCartQuantities();
  }

  initMenu() {
    const button = document.querySelector('[data-mobile-menu-toggle]');
    const drawer = document.querySelector('[data-mobile-drawer]');
    const close = document.querySelector('[data-mobile-menu-close]');
    if (!button || !drawer || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    const setOpen = (open) => {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      button.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
    };

    button.addEventListener('click', () => setOpen(!drawer.classList.contains('is-open')));
    close?.addEventListener('click', () => setOpen(false));
    drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  initSearch() {
    const button = document.querySelector('[data-search-toggle]');
    const search = document.querySelector('[data-header-search]');
    if (!button || !search || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';

    button.addEventListener('click', () => {
      const open = !search.classList.contains('is-open');
      search.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', String(open));
      if (open) search.querySelector('input')?.focus();
    });
  }

  initHeroSliders() {
    this.root.querySelectorAll('[data-hero-slider]').forEach((slider) => {
      if (slider.dataset.bound === 'true') return;
      slider.dataset.bound = 'true';

      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-hero-dot]')];
      const prev = slider.querySelector('[data-hero-prev]');
      const next = slider.querySelector('[data-hero-next]');
      if (slides.length < 2) return;

      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer = null;
      const autoplay = slider.dataset.autoplay === 'true';
      const speed = Number.parseInt(slider.dataset.speed || '6000', 10);

      const showSlide = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === current);
          dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false');
        });
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => showSlide(current + 1), Math.max(speed, 3000));
        }
      };

      prev?.addEventListener('click', () => {
        showSlide(current - 1);
        start();
      });
      next?.addEventListener('click', () => {
        showSlide(current + 1);
        start();
      });
      dots.forEach((dot, index) => dot.addEventListener('click', () => {
        showSlide(index);
        start();
      }));
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      showSlide(current);
      start();
    });
  }

  initProductForms() {
    this.root.querySelectorAll('[data-product-form]').forEach((form) => {
      if (form.dataset.bound === 'true') return;
      form.dataset.bound = 'true';
      const select = form.querySelector('[data-variant-select]');
      if (!select) return;
      const section = form.closest('[data-product-section]') || document;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const status = section.querySelector('[data-product-status]');
      const submit = form.querySelector('[data-add-to-cart]');
      const submitText = submit?.querySelector('span');

      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        if (status) {
          status.textContent = available ? 'Em estoque e pronto para envio' : 'Produto indisponível';
          status.className = `product-form__status ${available ? 'in-stock' : 'out-of-stock'}`;
        }
        if (submit) submit.disabled = !available;
        if (submitText) submitText.textContent = available ? 'Adicionar ao carrinho' : 'Esgotado';
      });
    });
  }

  initCartQuantities() {
    this.root.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      if (input.dataset.bound === 'true') return;
      input.dataset.bound = 'true';
      input.addEventListener('change', () => input.form?.requestSubmit());
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new NexorTheme());
document.addEventListener('shopify:section:load', (event) => new NexorTheme(event.target));
